/**
 * Constantes da página de Integrações
 */

const defaultCustomPromptPlaceholder = `# INSTRUÇÃO PRINCIPAL DA IA DE ATENDIMENTO – [NOME DA SUA ACADEMIA]
Você é a assistente comercial da [NOME DA SUA ACADEMIA], uma escola de [SUAS ATIVIDADES - EX: natação e hidroginástica]. Seu papel é atender leads pelo WhatsApp de forma educada, profissional, consultiva e objetiva.

Seu objetivo é conduzir o cliente para o próximo passo do funil:
1. Entender o interesse.
2. Qualificar o perfil.
3. Marcar aula experimental.
4. Conduzir para matrícula.

1. Tom de voz:
- Use linguagem cordial, clara e profissional.
- Evite usar diminutivos (como aulinha, vaguinha, turminha).
- Termine sempre com perguntas de avanço (ex: 'Fica melhor pela manhã ou à noite?').`;

const defaultCustomRulesPlaceholder = `# DADOS FIXOS DA ACADEMIA
Endereço: [Rua, Número, Bairro, Ponto de Referência]
Diferenciais: [Ex: piscina aquecida, piscina coberta, água salinizada]

# VALORES E HORÁRIOS DE REFERÊNCIA
• [Modalidade 1 (Ex: Natação)]: [Ex: Mensal R$ 200, Semestral 6x R$ 180]
• [Modalidade 2 (Ex: Hidroginástica)]: [Ex: Mensal R$ 180, Anual 12x R$ 150]

# REGRAS OPERACIONAIS E OBJEÇÕES
• [Regra 1 (Ex: Crianças até 3 anos precisam de responsável na piscina)]
• [Regra 2 (Ex: Como lidar com 'Está fora do orçamento' ou 'Vou pensar')]`;

export const INTEGRATION_PROVIDERS = [
    {
        id: "openai",
        name: "OpenAI",
        icon: "mdi-robot-outline",
        color: "#10A37F",
        description: "IA generativa para assistentes inteligentes e automações de texto.",
        configFields: [
            { key: "apiKey", label: "API Key", type: "password", placeholder: "sk-...", required: true },
            { key: "organizationId", label: "Organization ID", type: "text", placeholder: "org-... (Opcional)", required: false },
            { key: "defaultModel", label: "Modelo Padrão", type: "select", options: ["gpt-4o", "gpt-4o-mini", "gpt-4-turbo", "gpt-3.5-turbo"], required: true },
            { key: "systemPrompt", label: "Prompt do Sistema", type: "textarea", placeholder: "Defina a personalidade e instruções do assistente...", required: false },
            { key: "customPrompt", label: "Diretrizes de Atendimento (Tom de Voz e Persona)", type: "textarea", placeholder: defaultCustomPromptPlaceholder, required: false },
            { key: "customRules", label: "Regras e Dados da Academia (Preços, Planos e Horários)", type: "textarea", placeholder: defaultCustomRulesPlaceholder, required: false }
        ],
        testPlaceholder: "Digite uma mensagem para testar a IA...",
        testEndpoint: "chat"
    },
    {
        id: "gemini",
        name: "Google Gemini",
        icon: "mdi-google",
        color: "#4285F4",
        description: "IA do Google para geração de conteúdo e análise de dados.",
        configFields: [
            { key: "apiKey", label: "API Key", type: "password", placeholder: "AIza...", required: true },
            // Modelos verificados via models.list — estáveis primeiro, preview com cota baixa ao final
            { key: "defaultModel", label: "Modelo Padrão", type: "select", options: [
                "gemini-2.5-flash",
                "gemini-3.5-flash",
                "gemini-3.1-flash-lite",
                "gemini-2.5-flash-lite",
                "gemini-2.5-pro",
                "gemini-2.0-flash",
                "gemini-3.1-pro-preview",
                "gemini-3-flash-preview",
            ], required: true },
            { key: "systemPrompt", label: "Prompt do Sistema", type: "textarea", placeholder: "Defina a personalidade e instruções do assistente...", required: false },
            { key: "customPrompt", label: "Diretrizes de Atendimento (Tom de Voz e Persona)", type: "textarea", placeholder: defaultCustomPromptPlaceholder, required: false },
            { key: "customRules", label: "Regras e Dados da Academia (Preços, Planos e Horários)", type: "textarea", placeholder: defaultCustomRulesPlaceholder, required: false }
        ],
        testPlaceholder: "Digite uma mensagem para testar o Gemini...",
        testEndpoint: "chat"
    },
    {
        id: "evolution",
        name: "Evolution API",
        icon: "mdi-whatsapp",
        color: "#25D366",
        description: "API não oficial do WhatsApp para envio de mensagens e automações.",
        configFields: [
            { key: "apiUrl", label: "URL da API", type: "text", placeholder: "https://sua-api.com", required: true },
            { key: "apiKey", label: "Global API Key", type: "password", placeholder: "Sua chave global...", required: true },
            { key: "instanceName", label: "Nome da Instância", type: "text", placeholder: "minha-instancia", required: true },
            { key: "webhookUrl", label: "Webhook URL", type: "text", placeholder: "https://... (Opcional)", required: false }
        ],
        testPlaceholder: "Digite o número do WhatsApp (ex: 5511999887766)...",
        testEndpoint: "connection"
    }
];
